export default "__VITE_ASSET__I2_eDKu0__"